import {Box, Grid, Typography} from '@material-ui/core';
import React from 'react';

import {DocumentTitle} from 'components/Widgets';

import {getPageTitle} from '../../../consts/utilities';
import {LoginFormContainer} from '../components';
import {useStyles} from './styles';
import {useTheme} from '@material-ui/styles';

const Logo = () => {
  const theme = useTheme();

  return (
    <svg
      id="Layer_2"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 902.92 357.29"
      style={{
        width: '70%',
        height: 'auto',
      }}
    >
      <defs>
        <style>
          {`.cls-1 {
        fill: ${theme.palette['main-green-cta']};
      }

      .cls-2 {
        fill: ${theme.palette['main-indigo']};
      }

      .cls-3 {
        fill: #ffffff;
        stroke: ${theme.palette['main-indigo']};
        stroke-miterlimit: 10;
        stroke-width: 4px;
      }`}
        </style>
      </defs>
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Layer_2-2" data-name="Layer 2">
          <g>
            <path className="cls-3" d="M2,274.29v-116.49h26.74v116.49H2Z" />
            <path
              className="cls-3"
              d="M193.47,157.8h25.76v116.49h-23.79l-51.68-72.35v72.35h-25.76v-116.49h23.79l51.68,72.35v-72.35Z"
            />
            <path
              className="cls-3"
              d="M384.45,180.93h-49.71v24.77h46.27v22.97h-46.27v45.61h-26.25v-116.49h75.96v23.13h0Z"
            />
            <path
              className="cls-3"
              d="M463.03,274.29v-116.49h26.74v93.03h50.37l-1.64,23.46h-75.47,0Z"
            />
            <path
              className="cls-3"
              d="M690.6,157.8h26.58l.33,63c0,11.05-2.08,20.73-6.23,29.04-4.16,8.31-10.06,14.74-17.72,19.28s-16.68,6.81-27.07,6.81c-17.28,0-30.38-4.27-39.29-12.8-8.92-8.53-13.37-21.27-13.37-38.23v-67.1h26.74v64.97c0,10.39,2.24,17.88,6.73,22.48,4.48,4.59,10.77,6.89,18.87,6.89s14.14-2.65,18.46-7.96c4.32-5.3,6.42-13.59,6.32-24.86l-.33-61.53h-.02Z"
            />
            <path
              className="cls-3"
              d="M823.16,274.29h-29.53l38.56-58.9-36.42-57.59h30.19l21.66,34.95,21.49-34.95h28.71l-36.59,56.28,38.06,60.21h-30.68l-22.15-36.92-23.3,36.92h0Z"
            />
          </g>
          Name
          <circle className="cls-2" cx="480.97" cy="46.18" r="46.18" />
          <circle className="cls-2" cx="667.23" cy="46.18" r="46.18" />
          <circle
            className="cls-1"
            cx="853.11"
            cy="46.18"
            r="46.18"
            transform="translate(665.46 879.68) rotate(-80.41)"
          />
          <g>
            Name
            <path
              className="cls-2"
              d="M.21,356.99v-21.13h6.84c4.17,0,7.31.88,9.43,2.65,2.12,1.77,3.18,4.38,3.18,7.86,0,2.1-.48,3.95-1.43,5.53-.95,1.59-2.28,2.83-3.99,3.73-1.71.9-3.68,1.35-5.92,1.35H.2h0ZM5.06,352.67h3.06c2.16,0,3.8-.52,4.92-1.56s1.68-2.57,1.68-4.6c0-2.14-.58-3.73-1.74-4.78-1.16-1.04-2.94-1.56-5.34-1.56h-2.59v12.5h.01Z"
            />
            <path
              className="cls-2"
              d="M31.63,356.99l9.16-21.13h4.08l8.81,21.13h-4.94l-1.7-4.31h-8.72l-1.76,4.31h-4.94,0ZM39.99,348.63h5.45l-2.68-6.81-2.77,6.81Z"
            />
            <path
              className="cls-2"
              d="M81.32,335.86l-.62,4.25h-6.4v16.87h-4.88v-16.87h-6.7v-4.25h18.6,0Z"
            />
            <path
              className="cls-2"
              d="M90.07,356.99l9.16-21.13h4.08l8.81,21.13h-4.94l-1.7-4.31h-8.72l-1.76,4.31h-4.94,0ZM98.43,348.63h5.45l-2.68-6.81-2.77,6.81Z"
            />
            <path
              className="cls-1"
              d="M159.19,340.06h-9.02v4.49h8.39v4.17h-8.39v8.27h-4.76v-21.13h13.78v4.2Z"
            />
            <path className="cls-1" d="M173.44,356.99v-21.13h4.85v21.13h-4.85Z" />
            <path
              className="cls-1"
              d="M212.09,352.43l1.13,3.75c-.44.34-1,.6-1.68.8s-1.38.3-2.1.3c-1.29,0-2.42-.26-3.39-.79-.97-.52-1.78-1.29-2.41-2.31l-2.53-4.05c-.3-.48-.59-.81-.88-1s-.62-.29-1-.31v8.15h-4.76v-21.13h6.93c2.92,0,5.1.59,6.56,1.75,1.46,1.17,2.19,2.79,2.19,4.85,0,1.63-.5,2.96-1.5,3.99s-2.29,1.71-3.85,2.02c.65.32,1.23.84,1.73,1.58l1.01,1.55c.63.95,1.47,1.43,2.5,1.43.38,0,.73-.04,1.07-.13s.66-.24.98-.46h0ZM201.14,339.82h-1.9v5.24h1.87c1.49,0,2.56-.21,3.21-.64.65-.43.98-1.1.98-2.01s-.37-1.57-1.1-1.98-1.76-.61-3.06-.61h0Z"
            />
            <path
              className="cls-1"
              d="M233.07,357.25c-2.6,0-4.61-.55-6.04-1.67-1.43-1.11-2.24-2.75-2.44-4.91l4.55-.65c.12,1.03.53,1.82,1.22,2.37s1.66.82,2.89.82c1.05,0,1.86-.18,2.43-.55s.85-.89.85-1.56c0-.61-.3-1.1-.89-1.46-.6-.36-1.58-.69-2.95-1.01-1.47-.36-2.71-.79-3.72-1.29-1.01-.51-1.78-1.17-2.29-1.98-.52-.81-.77-1.84-.77-3.09s.34-2.47,1.01-3.48,1.62-1.8,2.83-2.37,2.61-.85,4.2-.85c2.06,0,3.75.53,5.06,1.58s2.06,2.49,2.26,4.32l-4.25.71c-.16-.81-.53-1.44-1.1-1.89-.58-.45-1.3-.67-2.17-.67s-1.58.2-2.11.61-.8.96-.8,1.65c0,.63.26,1.15.77,1.53.52.39,1.46.75,2.83,1.09,1.45.36,2.7.76,3.75,1.21,1.05.45,1.86,1.06,2.42,1.83.57.77.85,1.83.85,3.15s-.35,2.43-1.04,3.42-1.67,1.77-2.93,2.32c-1.26.56-2.72.83-4.39.83h-.03Z"
            />
            <path
              className="cls-1"
              d="M272.4,335.86l-.62,4.25h-6.4v16.87h-4.88v-16.87h-6.7v-4.25h18.6Z"
            />
            <path className="cls-2" d="M305.64,356.99v-21.13h4.85v21.13h-4.85Z" />
            <path
              className="cls-2"
              d="M340.36,335.86h4.67v21.13h-4.31l-9.37-13.12v13.12h-4.67v-21.13h4.31l9.37,13.12v-13.12Z"
            />
            <path
              className="cls-2"
              d="M374.99,340.06h-9.02v4.49h8.39v4.17h-8.39v8.27h-4.76v-21.13h13.78v4.2Z"
            />
            <path className="cls-2" d="M389.25,356.99v-21.13h4.85v16.87h9.13l-.3,4.26h-13.69.01Z" />
            <path
              className="cls-2"
              d="M430.52,335.86h4.82l.06,11.43c0,2-.38,3.76-1.13,5.27-.75,1.51-1.83,2.67-3.21,3.5-1.39.82-3.03,1.23-4.91,1.23-3.13,0-5.51-.77-7.13-2.32-1.62-1.55-2.42-3.86-2.42-6.93v-12.17h4.85v11.78c0,1.88.41,3.24,1.22,4.08.81.83,1.95,1.25,3.42,1.25s2.56-.48,3.35-1.44c.78-.96,1.16-2.46,1.15-4.51l-.06-11.16h0Z"
            />
            <path
              className="cls-2"
              d="M465.92,340.06h-9.7v4.19h9.08v4.2h-9.08v4.34h10l-.3,4.2h-14.46v-21.13h14.46v4.2h0Z"
            />
            <path
              className="cls-2"
              d="M494.58,335.86h4.67v21.13h-4.31l-9.37-13.12v13.12h-4.67v-21.13h4.31l9.37,13.12v-13.12Z"
            />
            <path
              className="cls-2"
              d="M534.06,352.85c-.87,1.43-2.07,2.52-3.6,3.29s-3.22,1.15-5.09,1.15c-2.28,0-4.23-.42-5.85-1.25s-2.86-2.03-3.72-3.58c-.86-1.56-1.29-3.43-1.29-5.61s.48-4.21,1.43-5.89c.95-1.69,2.28-3.01,3.97-3.96,1.7-.95,3.65-1.43,5.88-1.43,1.94,0,3.59.36,4.92,1.07s2.46,1.8,3.38,3.24l-3.72,2.65c-.48-.91-1.13-1.58-1.96-1.99-.83-.42-1.73-.63-2.68-.63-1.25,0-2.34.29-3.27.86-.93.58-1.66,1.38-2.19,2.41s-.79,2.22-.79,3.57c0,1.96.52,3.49,1.55,4.58,1.03,1.09,2.49,1.64,4.37,1.64,1.01,0,1.97-.24,2.87-.73.9-.49,1.63-1.23,2.19-2.22l3.6,2.83Z"
            />
            <path
              className="cls-2"
              d="M562.33,340.06h-9.7v4.19h9.08v4.2h-9.08v4.34h10l-.3,4.2h-14.46v-21.13h14.46v4.2h0Z"
            />
            <path
              className="cls-2"
              d="M594.91,352.43l1.13,3.75c-.44.34-1,.6-1.68.8-.68.2-1.38.3-2.1.3-1.29,0-2.42-.26-3.39-.79-.97-.52-1.78-1.29-2.41-2.31l-2.53-4.05c-.3-.48-.59-.81-.88-1s-.62-.29-1-.31v8.15h-4.76v-21.13h6.93c2.92,0,5.1.59,6.56,1.75,1.46,1.17,2.19,2.79,2.19,4.85,0,1.63-.5,2.96-1.5,3.99s-2.29,1.71-3.85,2.02c.65.32,1.23.84,1.73,1.58l1.01,1.55c.63.95,1.47,1.43,2.5,1.43.38,0,.73-.04,1.07-.13s.66-.24.98-.46h0ZM583.96,339.82h-1.9v5.24h1.88c1.49,0,2.56-.21,3.21-.64.65-.43.98-1.1.98-2.01s-.37-1.57-1.1-1.98-1.75-.61-3.06-.61h-.01Z"
            />
            <path
              className="cls-2"
              d="M628.65,356.99l.74-21.13h4.08l7.41,15.03,7.35-15.03h4.08l.57,21.13h-4.7l-.27-11.01-5.44,11.01h-3.54l-5.39-10.89-.39,10.89h-4.5Z"
            />
            <path
              className="cls-2"
              d="M666.35,356.99l9.16-21.13h4.08l8.81,21.13h-4.94l-1.7-4.31h-8.72l-1.75,4.31h-4.94ZM674.71,348.63h5.44l-2.68-6.81-2.77,6.81h.01Z"
            />
            <path
              className="cls-2"
              d="M719.61,352.43l1.13,3.75c-.44.34-1,.6-1.68.8-.68.2-1.38.3-2.1.3-1.29,0-2.42-.26-3.39-.79-.97-.52-1.78-1.29-2.41-2.31l-2.53-4.05c-.3-.48-.59-.81-.88-1s-.62-.29-1-.31v8.15h-4.76v-21.13h6.93c2.92,0,5.1.59,6.56,1.75,1.46,1.17,2.19,2.79,2.19,4.85,0,1.63-.5,2.96-1.5,3.99s-2.29,1.71-3.85,2.02c.65.32,1.23.84,1.73,1.58l1.01,1.55c.63.95,1.47,1.43,2.5,1.43.38,0,.73-.04,1.07-.13s.66-.24.98-.46h0ZM708.66,339.82h-1.9v5.24h1.88c1.49,0,2.56-.21,3.21-.64.65-.43.98-1.1.98-2.01s-.37-1.57-1.1-1.98-1.75-.61-3.06-.61h-.01Z"
            />
            <path
              className="cls-2"
              d="M733.89,356.99v-21.13h4.85v9.13l8.21-9.13h5.83l-9.61,10.56c.46.24.87.55,1.23.92.37.38.7.79,1,1.25l1.81,2.95c.34.54.7.92,1.09,1.15.39.23.86.34,1.41.34.38,0,.73-.04,1.07-.13s.67-.24,1.01-.46l1.1,3.75c-.42.34-.97.6-1.65.8-.68.2-1.39.3-2.13.3-2.6,0-4.53-1.03-5.8-3.09l-2.53-4.05c-.3-.48-.6-.84-.89-1.09-.3-.25-.68-.41-1.16-.49v8.42h-4.85.01Z"
            />
            <path
              className="cls-2"
              d="M780.57,340.06h-9.7v4.19h9.08v4.2h-9.08v4.34h10l-.3,4.2h-14.46v-21.13h14.46v4.2h0Z"
            />
            <path
              className="cls-2"
              d="M812.05,335.86l-.63,4.25h-6.4v16.87h-4.88v-16.87h-6.7v-4.25h18.61Z"
            />
            <path className="cls-2" d="M825.59,356.99v-21.13h4.85v21.13h-4.85Z" />
            <path
              className="cls-2"
              d="M860.31,335.86h4.67v21.13h-4.31l-9.37-13.12v13.12h-4.67v-21.13h4.31l9.37,13.12v-13.12Z"
            />
            <path
              className="cls-2"
              d="M891.68,345.5h9.02v11.48h-3.84l-.36-1.96c-.67.81-1.54,1.39-2.6,1.74-1.06.35-2.18.52-3.35.52-2.1,0-3.92-.42-5.46-1.25s-2.73-2.03-3.57-3.58c-.84-1.56-1.26-3.43-1.26-5.61s.48-4.18,1.44-5.88,2.33-3.02,4.09-3.97c1.77-.95,3.84-1.43,6.22-1.43,2,0,3.69.35,5.07,1.06,1.38.7,2.53,1.77,3.47,3.2l-3.72,2.71c-.5-.89-1.18-1.54-2.05-1.95s-1.8-.61-2.77-.61c-1.39,0-2.58.28-3.57.85s-1.76,1.36-2.31,2.38-.82,2.21-.82,3.56c0,1.96.52,3.48,1.55,4.55s2.45,1.61,4.26,1.61c.71,0,1.43-.12,2.14-.37s1.32-.63,1.83-1.15.81-1.16.91-1.93h-4.31v-3.96h-.01Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

const Login: React.FC = () => {
  const classes = useStyles();
  return (
    <>
      <DocumentTitle title={getPageTitle('Login')} />

      <Grid container alignItems="stretch">
        <Grid
          item
          container
          xs={12}
          lg={6}
          justifyContent="center"
          alignItems="center"
          className={classes.grid}
        >
          <Logo />
        </Grid>
        <Grid
          item
          container
          xs={12}
          lg={6}
          justifyContent="center"
          alignItems="center"
          className={classes.loginFormGrid}
        >
          <LoginFormContainer />
        </Grid>
      </Grid>
    </>
  );
};

export default Login;
